import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";
import { Logo } from "../components/Navbar";

export default function Login() {
  const { login } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email.trim(), password);
      toast.success(`Welcome back, ${user.name?.split(" ")[0] || "there"}`);
      const next = params.get("next");
      navigate(next || (user.role === "seller" ? "/seller" : "/"));
    } catch (err) {
      toast.error("Login failed", { description: err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-[70vh] flex items-center justify-center bg-[#F8FAF7] px-4 py-16">
      <div className="w-full max-w-md rounded-3xl border border-teal-900/10 bg-white p-8 shadow-xl shadow-teal-900/5">
        <div className="flex justify-center"><Logo /></div>
        <h1 className="font-heading mt-6 text-center text-2xl font-bold text-slate-900">{t("login_t")}</h1>
        <p className="mt-1 text-center text-sm text-slate-500">{t("login_sub")}</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label htmlFor="login-email" className="text-sm font-medium text-slate-700">{t("email")}</label>
            <input
              id="login-email"
              data-testid="login-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2.5 text-sm outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20"
            />
          </div>
          <div>
            <label htmlFor="login-password" className="text-sm font-medium text-slate-700">{t("password")}</label>
            <input
              id="login-password"
              data-testid="login-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2.5 text-sm outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20"
            />
          </div>
          <button
            data-testid="login-submit-button"
            type="submit"
            disabled={loading}
            className="w-full rounded-lg bg-teal-700 py-3 text-sm font-bold text-white shadow-md shadow-teal-700/25 hover:bg-teal-800 transition active:scale-95 disabled:opacity-60"
          >
            {loading ? t("logging_in") : t("login_btn")}
          </button>
        </form>
        <p data-testid="login-support-note" className="mt-4 rounded-xl bg-slate-50 px-4 py-3 text-center text-xs text-slate-500">
          {t("forgot_note")}{" "}
          <a data-testid="login-support-link" href="mailto:support@simashi01.com" className="font-semibold text-teal-700 hover:underline">
            support@simashi01.com
          </a>
        </p>
        <p className="mt-6 text-center text-sm text-slate-600">
          {t("new_here")}{" "}
          <Link data-testid="login-to-register-link" to="/register" className="font-semibold text-teal-700 hover:underline">
            {t("create_acc")}
          </Link>
        </p>
      </div>
    </div>
  );
}
